export interface Unit {
    key: string;
    label: string;
    abbr?: string;
}

export const units: Unit[] = [
    // Volume
    { key: "teaspoon", label: "teaspoon", abbr: "tsp" },
    { key: "tablespoon", label: "tablespoon", abbr: "Tbsp" },
    { key: "cup", label: "cup" },
    { key: "milliliter", label: "milliliter", abbr: "ml" },
    { key: "fluid_ounce", label: "fluid ounce", abbr: "fl oz" },

    // Weight
    { key: "ounce", label: "ounce", abbr: "oz" },
    { key: "pound", label: "pound", abbr: "lb" },
    { key: "gram", label: "gram", abbr: "g" },
    { key: "kilogram", label: "kilogram", abbr: "kg" },
    { key: "milligram", label: "milligram", abbr: "mg" },

    // General / Count / Less Common
    { key: "piece", label: "piece" },
    { key: "pinch", label: "pinch" },
    { key: "dash", label: "dash" },
    { key: "clove", label: "clove" },
    { key: "slice", label: "slice" },
    { key: "stick", label: "stick" },
    { key: "can", label: "can" },
    { key: "bottle", label: "bottle" },
    { key: "bag", label: "bag" },
    { key: "package", label: "package" },
    { key: "bunch", label: "bunch" },
    { key: "pint", label: "pint" },
    { key: "quart", label: "quart" },
    { key: "gallon", label: "gallon" },
    { key: "liter", label: "liter", abbr: "l" }
];

export const unitDisplayByKey = new Map(units.map(({ key, label, abbr }) => [key, abbr || label]));

export const unitOptions = units.map(({ key, label, abbr }) => ({ key, label: `${label}${abbr ? ` (${abbr})` : ""}` }));
